import React from "react";

const RehabilitationIcon = ({
  className = "w-11 h-11",
  viewBox = "0 0 44 44",
  fill = "currentColor",
  stroke = "currentColor",
  strokeWidth = "2",
  ...props
}) => (
  <svg
    className={className}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 4C32.493 4 41 12.507 41 23C41 33.493 32.493 42 22 42C11.507 42 3 33.493 3 23C3 12.507 11.507 4 22 4ZM22 8C13.716 8 7 14.716 7 23C7 31.284 13.716 38 22 38C30.284 38 37 31.284 37 23C37 14.716 30.284 8 22 8ZM22 13C23.105 13 24 13.895 24 15V23.414L28.293 27.707C29.098 28.512 29.098 29.805 28.293 30.61C27.488 31.415 26.195 31.415 25.39 30.61L20.586 25.806C20.211 25.431 20 24.923 20 24.392V15C20 13.895 20.895 13 22 13Z"
      fill={fill}
    />
  </svg>
);

export default RehabilitationIcon;
